import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_URI } from '../constants/appConstants';

function useAvailableMasseusesSlots(refetchIntervalMs = 0) {
  const fetchAvailableMasseusesSlots = async () => {
    const endpoint = `${API_URI}/masseuses/slots/`;
    try {
      const response = await axios.get(endpoint);

      // Pre-sort the data before returning to avoid re-sorting on each render
      return response.data?.sort(
        (a, b) => new Date(a.start_time) - new Date(b.start_time),
      );
    } catch (error) {
      throw new Error('Failed to fetch available masseuse slot list', {
        cause: error,
      });
    }
  };

  const queryKey = ['availableMasseusesSlots'];

  const { data, error, isPending } = useQuery({
    queryKey,
    queryFn: fetchAvailableMasseusesSlots,
    gcTime: 0, // Don't keep old data in garbage collection
    staleTime: 0, // Always consider data stale to allow refetching
    refetchInterval: refetchIntervalMs,
    refetchOnWindowFocus: 'always', // Always refetch when user returns to the tab
    refetchOnMount: 'always', // Always refetch when component mounts
    refetchOnReconnect: 'always', // Always refetch when network reconnects
    retry: 1, // Add a single retry for network failures
  });

  return {
    availableMasseusesSlots: data,
    isLoading: isPending, // Renamed property but kept return interface the same
    error,
  };
}

export default useAvailableMasseusesSlots;
